import { createSlice } from "@reduxjs/toolkit";
import { readFromLocalStorage, saveToLocalStorage } from "utils/helper";

const initialState = {
  data: (() => {
    const storedData = readFromLocalStorage("userRoles");
    return storedData ? storedData : [];
  })(),
  isFetching: false,
  error: null,
};

export const userRoles = createSlice({
  name: "userRoles",
  initialState,
  reducers: {
    setRolesBegin: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    setRolesSuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData;
      saveToLocalStorage("userRoles", newData);
    },

    setRolesError: (state, action) => {
      const { message = null } = action.payload;
      state.isFetching = false;
      state.error = message;
      state.data = [];
      localStorage.removeItem("userRoles");
    },

    resetState: (state) => {
      return initialState;
    },
  },
});

export const { setRolesBegin, setRolesSuccess, setRolesError } =
  userRoles.actions;

export const userRolesSelector = (state) => state.userRoles.data;

export default userRoles.reducer;
